import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Portador } from '../interfaces/portador';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { UnMedida } from '../interfaces/un-medida';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class PortadorService {

  readonly path = '/portador';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  create(): Observable<Portador> {
    return this.http.post<Portador>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(portador: Portador): Observable<Portador> {
    return this.http.put<Portador>(`${this.jwtAuthService.apiUrl + this.path}`, portador);
  }

  getPortador(id: number ): Observable<Portador> {
    return this.http.get<Portador>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getPortadorPage(page?: number, size?: number,
    order = 'NENHUM', direction = 'ASC'): Observable<PageResult<Portador>> {
    return this.http.get<PageResult<Portador>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getPortadorPageSearch(page?: number, size?: number,  search?: string,
    order = 'NENHUM', direction = 'ASC'): Observable<PageResult<Portador>> {
    return this.http.get<PageResult<Portador>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  deletePortador(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }
}
